import { Component } from '@angular/core';
import { SkeletonComponent } from '../../../shared/skeleton/skeleton.component';

@Component({
  selector: 'app-job-logs-table-skeleton',
  templateUrl: './job-logs-table-skeleton.component.html',
  styleUrls: ['./job-logs-table-skeleton.component.scss'],
  imports: [SkeletonComponent],
})
export class JobLogsTableSkeletonComponent {
  readonly rows = [1, 2, 3, 4, 5, 6];
  readonly cols = [1, 2, 3, 4, 5, 6, 7, 8];
}